import { KeyValue } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { StrictValuePipe } from '../../shared/pipes/strict-value.pipe';
import { TranslationMessagesPipe } from '../../shared/pipes/translation-msg.pipe';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class SelectComponent implements OnInit {
  @Input() selectList: Map<string, string> = new Map<string, string>();
  @Input() strictValueKey?: string;
  private _controlName?: string;
  @Input() set controlName(value: string) {
    this._controlName = value;
    if (!this.name) {
      this.name = value;
    }
  }

  get formControlName(): string {
    return this._controlName!;
  }

  @Input() name?: string;

  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  notFoundText = '';

  constructor(
    private _strictValuePipe: StrictValuePipe,
    private msgPipe: TranslationMessagesPipe
  ) {}

  ngOnInit(): void {
    if (this.strictValueKey) {
      this.selectList = this._strictValuePipe.strictValues(
        this.strictValueKey!,
        true
      )!;
    }

    this.notFoundText = this.msgPipe.transformInstant('validators.noItems');
  }

  onChange(value: string): void {
    this.valueChange.emit(value);
  }

  originalOrder(
    a: KeyValue<string, string>,
    b: KeyValue<string, string>
  ): number {
    return 0;
  }
}
